import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetSignalOverview } from "widgets";
import { WidgetSignalOverviewPreviewQuery } from "./__generated__/WidgetSignalOverviewPreviewQuery.graphql";

type Props = {
  storecastId: string;
  query: PreloadedQuery<WidgetSignalOverviewPreviewQuery>;
};

export const WIDGET_SIGNAL_OVERVIEW_PREVIEW_QUERY = graphql`
  query WidgetSignalOverviewPreviewQuery(
    $storecastId: ID!
    $input: PreviewWidgetSignalOverviewInput!
  ) {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetSignalOverview(input: $input) {
        ...WidgetSignalOverview_widget
      }
    }
  }
`;
export function WidgetSignalOverviewPreview(props: Props) {
  const data = usePreloadedQuery<WidgetSignalOverviewPreviewQuery>(
    WIDGET_SIGNAL_OVERVIEW_PREVIEW_QUERY,
    props.query
  );

  return (
    <WidgetSignalOverview
      mode="IDLE"
      interactive={false}
      widget={data.dashboard.previewWidgetSignalOverview}
      storecastId={props.storecastId}
    />
  );
}
